/**
 * @module support/shared/widgets
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

/**
 * A T-mobile customm design legalText component.
 * A tmo-legal-text component can be used overall the application to display the legal disclaimer
 * which is fetched from AEM
 */

import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { CtaButton } from './models/cta-button.interface';
import { AuthorableComponent } from '@core/aem/models/authorable-component.model';
import { Router } from '@angular/router';
import { PERMISSION_CONSTANTS } from '@support/shared/constants/permission.constants';
import { APP_PERMISSION } from '@support/shared/constants/device.constants';
import { FeatureToggleUtilService } from '@support/shared/services/feature-toggle-util.service';
import { SHARED_CONSTANTS } from '@root/shared/constants/shared-constants.constants';

@Component({
  selector: 'tmo-cta-button-authorable',
  templateUrl: './cta-button.component.html',
})
export class CtaButtonComponent
  extends AuthorableComponent<CtaButton>
  implements OnInit, OnDestroy
{
  @Input() public text: String;
  @Input() public link: String;
  @Input() public target: String;
  @Input() public anchorId: String;
  @Input() public buttonStyle: String;
  @Input() public css: string;
  @Input() public impression: boolean;
  /**
   * flag to store permission
   */
  public isShowDevicesPermission: boolean;
  /**
   * flag to store permission
   */
  public isDevicePermissionAvailable: boolean;
  /**
   * Whenever this component needs some value to be instantiated on load then
   * values of its properties are initialised in the constructor
   * @returns void
   */
  constructor(
    private router: Router,
    private featureToggleUtilService: FeatureToggleUtilService
  ) {
    super();
    this.isShowDevicesPermission = true;
    this.isDevicePermissionAvailable = true;
  }

  /**
   * Called whenever this component is invoked from parent component
   * @returns void
   */
  public ngOnInit(): void {}
  public setData(data: CtaButton): void {
    if (this.validate(data)) {
      this.text = data.text;
      this.link = data.link;
      if (data.text === APP_PERMISSION.DEVICES) {
        this.isShowDevicesPermission = this.featureToggleUtilService.getFraudLockPermission(
          SHARED_CONSTANTS.GLOBAL,
          PERMISSION_CONSTANTS.ORDER_DEVICE
        );
        this.isDevicePermissionAvailable = this.featureToggleUtilService.getFraudLockPermission(
          SHARED_CONSTANTS.GLOBAL,
          PERMISSION_CONSTANTS.PRE_ORDER_DEVICE
        );
      }
    }

    // Assign optionals
    this.target = data.target;
    this.css = data.css || '';
    this.anchorId = data.anchorId;
    this.buttonStyle = data.buttonStyle;
    this.impression = data.impression;
  }

  /**
   * Check if the data is valid, should throw an error if the input doesn't match designated fields
   * @param data
   */
  public validate(data: CtaButton): boolean {
    if (!data.text) {
      throw new Error(`Invalid options for text ${data}: Required fields [text]`);
    }
    return true;
  }

  public navigateTo(): void {
    this.router.navigate([this.link]);
  }
  /**
   * Destroys all the subscriptions .
   * @returns void
   */
  public ngOnDestroy(): void {}
}
